
export class Filter {
    dimension?: string; 
    attribute?: string;
    filterValues: string[] = [];
    dimensionId?: string;
    dimensionAttributeId?: string;
}
